const ConfigActionType = {
  STORE_PLANS_CONFIG: 'STORE_PLANS_CONFIG',
  STORE_STATIC_CONFIG: 'STORE_STATIC_CONFIG'
};

export default ConfigActionType;



/** WEBPACK FOOTER **
 ** ./src/common/ConfigActionType.js
 **/